export const PUBLISHING_GUIDES_ROUTE = '/resources/guides';

export type PublishingGuide = {
  id: string;
  title: string;
  description: string;
  subtitle: string;
  metaDescription: string;
  market: string;
  topics: string[];
  author: string;
  contributor: string;
  contributorUrl: string;
};

export const tolinoGuide: PublishingGuide = {
  id: 'tolino-for-indie-authors',
  title: 'Tolino for Indie Authors: A Mini Handbook',
  description: 'How to publish a German translation through the Tolino ecosystem, including direct distribution, pricing, Skoobe, Onleihe, fixed-price rules, and promotional opportunities.',
  subtitle: 'Publish your German translation with a better understanding of the Tolino ecosystem, German pricing rules, and the advantages available to authors who publish directly through tolino media.',
  metaDescription: 'A practical guide to publishing a German translation through Tolino, including direct distribution, royalties, pricing rules, Skoobe, Onleihe, and promotional opportunities.',
  market: 'Germany',
  topics: ['Distribution', 'Pricing', 'Retailers'],
  author: 'Anastasia Rydaeva',
  contributor: 'Cowper Author Services',
  contributorUrl: 'https://cowperauthorservices.com/',
};

export const publishingGuides: PublishingGuide[] = [tolinoGuide];
export const getPublishingGuideRoute = (guide: PublishingGuide) => `${PUBLISHING_GUIDES_ROUTE}/${guide.id}`;
